<template>
  <div class="calendar-container">
    <div class="calendar-header">
      <button class="today-btn" @click="goToday">오늘</button>
      <div class="month-title">
        {{ currentYear }}년 {{ currentMonth + 1 }}월
      </div>
      <div class="nav-buttons">
        <button @click="prevMonth">‹</button>
        <button @click="nextMonth">›</button>
      </div>
    </div>

    <div class="weekdays">
      <div v-for="(d, i) in weekdays" :key="i">{{ d }}</div>
    </div>

    <div class="dates-grid">
      <div
        v-for="(date, index) in calendarDays"
        :key="index"
        class="date-cell"
        :class="{
          'is-today': isToday(date),
          'is-selected': isSelected(date),
          'is-other-month': date.getMonth() !== currentMonth
        }"
        @click="selectDate(date)"
      >
        {{ date.getDate() }}
      </div>
    </div>
    <span class="month-title" style="font-size: 2.2vw;">시간을 선택해 주세요</span>
    <div class="list" style="margin-top: 1vh;">
      
      <div class="slot" v-for="(slot, index) in list" :key="`slot_${index}`" @click="selectSlot">{{ slot }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Calendar',
  props: {
    value: { type: Date, default: () => new Date() }
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth(),
      selectedDate: new Date(),
      list: ['10:10 ~ 10:30', '11:00 ~ 11:30', '12:00 ~ 12:30', '13:00 ~ 13:30', '14:00 ~ 14:30', '15:00 ~ 15:30', '16:00 ~ 16:30', '17:00 ~ 17:30', '18:00 ~ 18:30', '19:00 ~ 19:30',  ]
    };
  },
  computed: {
    weekdays() {
      return ['일', '월', '화', '수', '목', '금', '토'];
    },
    calendarDays() {
      const firstDay = new Date(this.currentYear, this.currentMonth, 1);
      const startDay = firstDay.getDay();
      const daysInMonth = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
      const daysInPrevMonth = new Date(this.currentYear, this.currentMonth, 0).getDate();

      const days = [];

      // 이전 달 날짜 채우기
      for (let i = startDay - 1; i >= 0; i--) {
        days.push(new Date(this.currentYear, this.currentMonth - 1, daysInPrevMonth - i));
      }

      // 현재 달 날짜
      for (let i = 1; i <= daysInMonth; i++) {
        days.push(new Date(this.currentYear, this.currentMonth, i));
      }

      // 다음 달 날짜 채우기 (42칸 맞추기)
      while (days.length < 42) {
        days.push(new Date(this.currentYear, this.currentMonth + 1, days.length - (startDay + daysInMonth) + 1));
      }

      return days;
    }
  },
  methods: {
    isToday(date) {
      const today = new Date();
      return (
        date.getFullYear() === today.getFullYear() &&
        date.getMonth() === today.getMonth() &&
        date.getDate() === today.getDate()
      );
    },
    isSelected(date) {
      return (
        date.getFullYear() === this.selectedDate.getFullYear() &&
        date.getMonth() === this.selectedDate.getMonth() &&
        date.getDate() === this.selectedDate.getDate()
      );
    },
    selectDate(date) {
        this.selectedDate = date;
        // slot list 
        // alert("")
    },
    selectSlot: function()
    {
        this.$emit('dateSelected');
    },
    prevMonth() {
      if (this.currentMonth === 0) {
        this.currentMonth = 11;
        this.currentYear--;
      } else {
        this.currentMonth--;
      }
    },
    nextMonth() {
      if (this.currentMonth === 11) {
        this.currentMonth = 0;
        this.currentYear++;
      } else {
        this.currentMonth++;
      }
    },
    goToday() {
      const today = new Date();
      this.currentYear = today.getFullYear();
      this.currentMonth = today.getMonth();
      this.selectDate(today);
    }
  },
  mounted() {
    this.selectDate(this.value || new Date());
  }
};
</script>

<style scoped>
.calendar-container {
  width: 100%;
  margin: 0 auto;
  font-family: 'Noto Sans KR', sans-serif;
  padding: 0 8vw;
  box-sizing: border-box;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 4vw;
  margin-bottom: 1.5vh;
}

.today-btn {
  color: #007bff;
  background: none;
  border: none;
  font-weight: 500;
  cursor: pointer;
  font-size: 3vw;
}

.month-title {
  font-weight: 600;
  font-size: 3vw
}

.nav-buttons button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 5vw
}

.weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  color: #999;
  font-weight: 500;
  margin-bottom: 8px;
  font-size: 2vw;
}

.dates-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
}

.date-cell {
  padding: 10px 0;
  border-radius: 50%;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center; 
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 2.5vw;
  box-sizing: border-box;
}

.date-cell.is-other-month {
  color: #ccc;
}

.date-cell.is-today {
  border: 1px solid #007bff;
  color: #007bff;
}

.date-cell.is-selected {
  background-color: #007bff;
  color: white;
}
.list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 2vw;
    overflow-x: auto;
    width: 100%;
    white-space: nowrap; /* 줄바꿈 방지 */
}
.slot {
    border-radius: 6px;
    background: #F3F5F8;
    box-sizing: border-box;
    padding: 0 1.7vw;
    aspect-ratio: 19/6;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1vw;
    color: #1E1E1E;
    text-align: center;
    font-family: Pretendard;
    font-size: 1.7vw;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/showcase/Calendar.vue